export const defaultSelector = (target: any): any => target;
